import { Card, CardBody, Col, Row } from "reactstrap";
import { H2, Image, P, H4, Btn } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { useState, useEffect } from "react";
import { useApiHelper } from "../../../utils/helper/apiHelper";
import { useBotService } from "../../../Service/ActivateBot/ActivateBot";
import { decryptData } from "../../../utils/helper/Crypto";
import { useSweetAlert } from "../../../Context/SweetAlertContext";
import { env } from "process";

const EditMyProfile = (props: any) => {
  const [imageUploaderLoading, setImageUploaderLoading] = useState(false);
  const [profileUploadPic, setProfileUploadPic] = useState("");
  const [profilePicPreview, setProfilePicPreview] = useState("");
  const { post } = useApiHelper();
  const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();
  const [UserName] = useState(localStorage.getItem("UserName"));

  const { ExecuteProcedure } = useBotService();
  const [memberID, setmemberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );
  // Handle form submit
  //alert(process.env.REACT_APP_ADMINURL)

  const UpdateProfilePic = async (profileUploadPic: any) => {
    const param = {
      ClientId: memberID,
      ProfilePic: profileUploadPic,
      ActionMode: "UpdateProfilePic",
    };
    const obj = {
      procName: "UpdateProfile",
      Para: JSON.stringify(param),
    };

    const res = await ExecuteProcedure(obj);
    if (res[0].StatusCode === "1") {
      ShowSuccessAlert(res[0].Msg);
    } else {
      showAlert(res[0].Msg);
      return;
    }
  };

  // Consolidated function to handle both image upload and preview
  const handleProfileChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      // Generate preview for the uploaded image
      const reader = new FileReader();
      reader.onloadend = async () => {
        setProfilePicPreview(reader.result as string); // Preview image

        // Now upload the image
        setImageUploaderLoading(true);
        const formData = new FormData();
        formData.append("imgData", file);
        formData.append("pagename", "profilepic");

        try {
          const response = await post(
            import.meta.env.VITE_APP_API_URL + "/PostUserImage",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          if (response.Message) {
            console.log("Uploaded file name:", response.Message);
            setProfileUploadPic(response.Message); // Save uploaded filename to state
            UpdateProfilePic(response.Message);
          }
        } catch (error) {
          console.error("Upload failed:", error);
        } finally {
          setImageUploaderLoading(false);
        }
      };

      reader.readAsDataURL(file);
    }
  };
  return (
    <Col xl="12">
      <Card>
        <CardBody>
          <Row className="mb-2">
            <div className="profile-title">
              <div className="d-flex flex-wrap flex-md-nowrap justify-content-center">
                <div className="profile-pic-wrapper">
                  <Image
                    className="img-md-120 rounded-circle"
                    alt="edit-user"
                    src={
                      profilePicPreview
                        ? profilePicPreview
                        : `${import.meta.env.VITE_APP_ADMINURL}ClientImage/` +
                          props?.user_Data[0]?.ProfilePic
                    }
                  />
                  {/* Hidden file input */}
                  <input
                    id="profileUpload"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleProfileChange}
                    style={{ display: "none" }}
                  />
                  {/* Edit button */}
                  <label htmlFor="profileUpload" className="edit-btn">
                    <i className="fa fa-pencil" />
                  </label>
                </div>

                {imageUploaderLoading && <p>Uploading...</p>}

                <div className="flex-grow-1 text-center text-sm-start">
                  <H2 className="mb-1 text-center text-sm-start">
                    {props?.user_Data[0]?.FirstName} <p className="text-sm mt-1 mb-1">{UserName}</p>
                  </H2>
                  <H4 className="text-center text-sm-start">
                    {props?.user_Data[0]?.EmailId}
                  </H4>
                  <hr />
                  <P
                    className={
                      props?.user_Data[0]?.RankName === "No Rank"
                        ? "badge badge-danger f-18"
                        : "badge badge-info f-18"
                    }
                  >
                    {props?.user_Data[0]?.RankName}
                  </P>
                </div>
              </div>
            </div>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EditMyProfile;
